import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Component/Header';

function Album() {

    const { id, name } = useParams();

    const navigate = useNavigate();

    const [albums, setAlbums] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [categories, setCategories] = useState([]);

    const [activeCategory, setActiveCategory] = useState(null);
    const [activeSubcategory, setActiveSubcategory] = useState(null);

    /*
     * Get current URL type
     *
     * /album/category/1/TEST
     * /album/subcategory/2/Subtest
     */
    const isSubcategoryPage =
        window.location.pathname.includes('/album/subcategory/');

    const isCategoryPage =
        window.location.pathname.includes('/album/category/');


    /*
     * Fetch categories
     */
    useEffect(() => {

        const fetchCategories = async () => {

            try {

                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/getcategories`
                );

                if (!response.ok) {
                    throw new Error(
                        `Error: ${response.status}`
                    );
                }

                const result = await response.json();

                const categoryData = result.data || [];

                setCategories(categoryData);

                /*
                 * If user opened:
                 *
                 * http://localhost:5000/album
                 *
                 * automatically open first category.
                 */
                if (!id && categoryData.length > 0) {

                    const firstCategory = categoryData[0];

                    navigate(
                        `/album/category/${firstCategory.category_id}/${encodeURIComponent(
                            firstCategory.category
                        )}`,
                        { replace: true }
                    );
                }

            } catch (error) {

                console.error(
                    'Failed to fetch categories:',
                    error
                );

                setError(
                    'Failed to load categories'
                );
            }
        };

        fetchCategories();

    }, [id, navigate]);


    /*
     * Fetch album images
     */
    useEffect(() => {

        if (!id) {
            return;
        }

        const fetchAlbums = async () => {

            try {

                setLoading(true);
                setError('');

                let apiUrl = '';

                /*
                 * SUBCATEGORY
                 */
                if (isSubcategoryPage) {

                    apiUrl =
                        `${process.env.REACT_APP_API_URL}/albums/subcategory/${id}`;

                    setActiveSubcategory(Number(id));
                    setActiveCategory(null);
                }

                /*
                 * CATEGORY
                 */
                else if (isCategoryPage) {

                    apiUrl =
                        `${process.env.REACT_APP_API_URL}/albums/category/${id}`;

                    setActiveCategory(Number(id));
                    setActiveSubcategory(null);
                }

                else {

                    setLoading(false);
                    return;
                }


                const response = await fetch(apiUrl);


                /*
                 * Backend returns 404 when
                 * there are no images.
                 */
                if (response.status === 404) {

                    setAlbums([]);
                    setLoading(false);

                    return;
                }


                if (!response.ok) {

                    throw new Error(
                        `Error: ${response.status}`
                    );
                }


                const result = await response.json();


                const albumData =
                    (result.albums || []).sort(
                        (a, b) =>
                            Number(a.serial_no) -
                            Number(b.serial_no)
                    );


                setAlbums(albumData);

                setLoading(false);

            } catch (error) {

                console.error(
                    'Failed to load albums:',
                    error
                );

                setError(
                    'Failed to load album images'
                );

                setAlbums([]);
                setLoading(false);
            }
        };


        fetchAlbums();

    }, [id, isCategoryPage, isSubcategoryPage]);


    return (
        <div>

            <Header
                activeCategory={activeCategory}
                activeSubcategory={activeSubcategory}
            />


            <div
                className="container px-3 px-md-5"
                style={{
                    marginTop: '110px'
                }}
            >

                {/* TITLE */}

                <h2
                    className="text-center"
                    style={{
                        fontSize:
                            'clamp(1.8rem, 5vw, 3rem)',
                        marginBottom: '30px'
                    }}
                >
                    {name
                        ? decodeURIComponent(name)
                        : 'Album'}
                </h2>


                {/* LOADING */}

                {loading && (
                    <div className="text-center">
                        Loading...
                    </div>
                )}


                {/* ERROR */}

                {!loading && error && (
                    <div className="text-center text-danger">
                        {error}
                    </div>
                )}


                {/* NO IMAGES */}

                {!loading &&
                    !error &&
                    albums.length === 0 && (

                        <div className="text-center">
                            No Images Found
                        </div>

                    )}


                {/* IMAGES */}

                {!loading &&
                    !error &&
                    albums.length > 0 && (

                        <div>

                            {albums.map((album) => (

                                <div
                                    key={album.album_id}
                                    style={{
                                        marginBottom: '20px'
                                    }}
                                >

                                    <img
                                        src={album.image_url}
                                        alt={
                                            name
                                                ? decodeURIComponent(name)
                                                : 'Album'
                                        }
                                        style={{
                                            width: '100%',
                                            borderRadius: '10px',
                                            objectFit: 'cover',
                                            display: 'block'
                                        }}
                                    />

                                </div>

                            ))}

                        </div>

                    )}

            </div>

        </div>
    );
}

export default Album;